export default __webpack_public_path__ + "static/p2-08a2b82b1ca8b8a168cdd98c19c9f965.png";